// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import PurchaseHistory from './PurchaseHistory';
import Subscriptions from './Subscriptions';
import { setForm } from '../../actions';
import {
    PURCHASE_HISTORY_FORM,
    SUBSCRIPTIONS_FORM,
} from '../../constants/forms';
import i18n from '../../i18n/i18n.js';

type Props = {
    branding: {
        paywall_primary_color: string,
    },
    auth: {
        language: string,
    },
    form: string,
    setForm: Function,
};

type State = {
    activePurchase: boolean,
    activeSubs: boolean,
};

export class HistoryTable extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            activePurchase: false,
            activeSubs: false,
        };
    }

    componentDidMount() {
        if (this.props.form === PURCHASE_HISTORY_FORM) {
            this.setState({
                activePurchase: true,
                activeSubs: false,
            });
        } else if (this.props.form === SUBSCRIPTIONS_FORM) {
            this.setState({
                activePurchase: false,
                activeSubs: true,
            });
        }
    }

    changeForm = form => {
        if (form === PURCHASE_HISTORY_FORM) {
            this.setState({
                activePurchase: true,
                activeSubs: false,
            });
        } else if (form === SUBSCRIPTIONS_FORM) {
            this.setState({
                activePurchase: false,
                activeSubs: true,
            });
        }

        this.props.setForm(form);
    };

    render() {
        let form = null;
        if (this.props.form === PURCHASE_HISTORY_FORM) {
            form = <PurchaseHistory />;
        } else if (this.props.form === SUBSCRIPTIONS_FORM) {
            form = <Subscriptions />;
        }

        let lng = this.props.auth.language;

        let borderBottomPurch;
        let borderBottomSubs;
        if (this.state.activePurchase) {
            borderBottomPurch =
                '2px solid ' + this.props.branding.paywall_primary_color;
        } else if (this.state.activeSubs) {
            borderBottomSubs =
                '2px solid ' + this.props.branding.paywall_primary_color;
        }

        return (
            <Fragment>
                <header>
                    <div className="headline">
                        <a
                            className={
                                'ipx-headlogin ' +
                                (this.state.activePurchase && 'active')
                            }
                            onClick={e => {
                                e.preventDefault();
                                this.changeForm(PURCHASE_HISTORY_FORM);
                            }}
                            style={{ borderBottom: borderBottomPurch }}
                        >
                            {i18n.t('purchases_link', { lng })}
                        </a>
                        /
                        <a
                            className={
                                'ipx-headregister ' +
                                (this.state.activeSubs && 'active')
                            }
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                this.changeForm(SUBSCRIPTIONS_FORM);
                            }}
                            style={{ borderBottom: borderBottomSubs }}
                        >
                            {i18n.t('subscriptions_link', { lng })}
                        </a>
                    </div>
                    {this.props.form === PURCHASE_HISTORY_FORM ? (
                        <div className="inplayer-customtext">
                            <p>{i18n.t('subscriptions_text', { lng })}</p>
                        </div>
                    ) : null}
                </header>
                {form}
            </Fragment>
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        auth: state.auth,
        form: state.modal.form,
        branding: state.branding,
    };
};

export default connect(
    mapStateToProps,
    {
        setForm,
    }
)(HistoryTable);



// WEBPACK FOOTER //
// ./src/containers/Forms/HistoryTable.js